<script setup lang="ts">
const { t } = useEkI18n();
const settingsStore = useSettingsStore();

async function updateSaveImagePreference(value: boolean) {
  await settingsStore.set('saveImageToDevice', value);
}
</script>

<template>
  <SettingsToggle
    :checked="settingsStore.settings.saveImageToDevice"
    :label="t('settings.documents.saveImagesToDevice')"
    :description="t('settings.documents.saveImagesToDeviceDescription')"
    @change="updateSaveImagePreference"
  />
</template>
